// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerSection {
  margin-top: 82px;
  height: 458px;
  background: #5b7cfd;
}

@media only screen and (max-width: 767.98px) {
  /* For screens smaller than medium (up to 767.98px) */
  .footerSection {
    display: none;
  }
}

.footerContentSetting {
  padding-top: 120px;
}

.footerLogoDownText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
  margin-top: 13px;
}
.linksSectionOne {
  margin-left: 113px;
}

@media only screen and (max-width: 767.98px) {
  /* For screens smaller than medium (up to 767.98px) */
  .linksSectionOne {
    margin-left: auto;
    margin-right: auto;
  }
}

.linksSectionTwo {
  margin-left: auto;
  margin-right: auto;
}

.linksSectionThree {
  margin-left: auto;
  margin-right: auto;
}
.footerLinkHeading {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}
.footerLinkItem {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #eeeeee;
  text-decoration: none;
}

.footerLinkHeadingAdress {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  margin-top: 20px;
}
.footerLinkItemAdress {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #eeeeee;
  text-decoration: none;
  padding-top: 30px;
}

.groupWorkingPara {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #716c80;
}

.coustomHrTagStyle {
  height: 0px;

  color: white;
  border: 1px solid #dedede;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/Calendex/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;;EAEX,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".footerSection {\n  margin-top: 82px;\n  height: 458px;\n  background: #5b7cfd;\n}\n\n@media only screen and (max-width: 767.98px) {\n  /* For screens smaller than medium (up to 767.98px) */\n  .footerSection {\n    display: none;\n  }\n}\n\n.footerContentSetting {\n  padding-top: 120px;\n}\n\n.footerLogoDownText {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 25px;\n  color: #ffffff;\n  margin-top: 13px;\n}\n.linksSectionOne {\n  margin-left: 113px;\n}\n\n@media only screen and (max-width: 767.98px) {\n  /* For screens smaller than medium (up to 767.98px) */\n  .linksSectionOne {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.linksSectionTwo {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.linksSectionThree {\n  margin-left: auto;\n  margin-right: auto;\n}\n.footerLinkHeading {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #ffffff;\n}\n.footerLinkItem {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #eeeeee;\n  text-decoration: none;\n}\n\n.footerLinkHeadingAdress {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #ffffff;\n  margin-top: 20px;\n}\n.footerLinkItemAdress {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #eeeeee;\n  text-decoration: none;\n  padding-top: 30px;\n}\n\n.groupWorkingPara {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 27px;\n  color: #716c80;\n}\n\n.coustomHrTagStyle {\n  height: 0px;\n\n  color: white;\n  border: 1px solid #dedede;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
